"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = exports.getWidthStyles = exports.getIdKey = void 0;
exports.reactDebounce = reactDebounce;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function reactDebounce(f, ms) {
  var timer = null;
  return function () {
    var _this = this;

    var ev = arguments[0];
    var savedArgs = arguments;
    if (ev.persist) ev.persist();
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      f.apply(_this, savedArgs);
      timer = null;
    }, ms);
  };
}

var DEFAULT_ID_KEY = 'id';

var getIdKey = function getIdKey(params) {
  return params.defaultId || DEFAULT_ID_KEY;
};

exports.getIdKey = getIdKey;

var isObject = function isObject(obj) {
  return _typeof(obj) === 'object' && obj !== null && !obj.map;
};

exports.isObject = isObject;

var getWidthStyles = function getWidthStyles(width) {
  if (!width) return;
  return {
    minWidth: "".concat(width, "px"),
    maxWidth: "".concat(width, "px"),
    width: "".concat(width, "px")
  };
};

exports.getWidthStyles = getWidthStyles;